import Cookies from "js-cookie";
var fetchTest = function fetchTest(_ref) {
  var name = _ref.name,
    data = _ref.data;
  var cookieURL = Cookies.get("track_collect_url");
  var trackWorkId = Cookies.get("track_work_id");
  if (!trackWorkId) {
    return;
  }
  var url = cookieURL || "https://meta.8891.tw/api/v1/collect"; // 替换为你要发送 POST 请求的 URL
  var params = {
    track_work_id: trackWorkId,
    event_name: name,
    data: data
  };
  var options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(params)
  };
  fetch(url, options);
};
export default fetchTest;